module.exports = "label {\r\n    color: #4285f4;\r\n}\r\n.row:nth-child(even) {\r\n    background-color: #f3f3f3;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/chitfund/schedule-generate/schedule-generate.component.css
// module id = ./src/app/chitfund/schedule-generate/schedule-generate.component.css
// module chunks = main